module.exports = __webpack_public_path__ + "static/media/trump4.f92419d0.jpg";